import { createEvent } from "@cobuildlab/react-simple-state";
import { LogsData } from "./logs-types";

export const OnFetchLogs = createEvent<LogsData[]>();
export const OnFetchLogsError = createEvent();